import react, { useEffect, useMemo } from "react"
import { StyleObject } from "styletron-react"
import { AttentionPopover } from "."
import { colors, fonts, frames } from "../Styles"

import { NavigationFunction, Pages } from "../Navigation/Routers/root"
import { useNavigate } from "react-router"
import { useAppSelector } from "../Store"
import { Graph_QL } from "../Services"
import { useSystem } from "../Services/Agrisys_GqlDataCaller/SystemCalls/useSystem"
interface StatusBar_Props {
    overrides?:{
        gridArea?: string
    }
  }

export default function StatusBar({overrides}:StatusBar_Props) {
  const farm = useAppSelector(({activeData}) => activeData.farm) ?? "";
  const domain = useMemo(() => (Graph_QL.ObjToString({domain: farm})),[farm]);
  const connection = useMemo(() => (Graph_QL.create({domain: farm})),[farm]);;

  const {call: getSystemCall, data: systemsState} = useSystem(connection); 
  
  useEffect(() => {
    getSystemCall({fetchAmount: 50})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const navigator = useNavigate()

  const BtnFunc_Router = (systemId: number) => {
    switch (systemId) {
      case 1: //Test Btn _ navi is not used
      NavigationFunction(navigator, Pages.autopig)
        break
      case 2: //Navigate Moblie _ index = 1
      NavigationFunction(navigator, Pages.freeda_lf)
        break
      default:
        alert("Error ???")
    }
  }
  
  const _Root = useMemo<StyleObject>(() => {
    return Object.assign(
      {} as StyleObject, //default stlye
        overrides&&overrides.gridArea? {gridArea:overrides.gridArea} : {}
    )
  },[overrides])
  
  return(
      <frames.StatusBar $style={_Root}>
      <p style={{ ...fonts.header, ...fonts.textShadow, ...fonts.fontSize4, color: colors.greyLightTertiary}}>System Status</p>
      <div style={{width: "2px", height: "50%", backgroundColor: colors.greyDarkSecondary}}/>
        <div style={{display: "flex", flexDirection: "row", gap: "10px", alignItems: "center", justifyContent: "center"}}>
          {systemsState[domain]?.data?.map((system) => (
            <AttentionPopover key={system.systemId} systemNo={system.systemId} onGoToSystemClick={() => BtnFunc_Router(system.systemId)} />
          ))}
        </div>
      </frames.StatusBar>

  )
}
